import { Directive, HostBinding } from '@angular/core';

/**
 * Permet d'appliquer l'attribut error sur les éléments
 * ciblés par les directions dans le dossier connectors
 */
@Directive({
  standalone: false
})
export class FormErrorConnectorDirective {
  private _hasError: boolean;

  @HostBinding('attr.error')
  get hasError() {
    return this._hasError;
  }
  set hasError(value: boolean) {
    this._hasError = value;
  }

  setInErrorState() {
    this.hasError = true;
  }

  setInValidState() {
    this.hasError = false;
  }
}
